<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Different modes and configurations of split buttons" />
    <vc-layout :spacing="8">
      <vc-col :span="12" xs24>
        <h4 :class="subheading">Default (split-mode, button click triggers event, arrow click expands the dropdown)</h4>
        <vc-button-split
          :items="button1"
          :header-click-value="split1"
          v-model="split1"
          @input="onInput($event)">Cat Things</vc-button-split>
        <div :class="['mt-16']">
          <code>v-model: {{ split1 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" xs24>
        <h4 :class="subheading">Menu Mode, "small" size (both button and arrow click expand the dropdown)</h4>
        <vc-button-split
          color="deep-purple"
          :dark="true"
          :items="button2"
          :header-click-value="split2"
          size="small"
          mode="menu"
          :dropdown-z-index="500"
          v-model="split2"
          @input="onInput($event)"
          icon="mdi-guitar-pick">Guitar Brands</vc-button-split>
        <div :class="['mt-16']">
          <code>v-model: {{ split2 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" xs24>
        <h4 :class="subheading">Default mode ("split"), custom color and icon</h4>
        <vc-button-split
          color="red"
          :dark="true"
          :items="button1"
          :header-click-value="split1"
          mode="split"
          size="normal"
          v-model="split1"
          @input="onInput($event)"
          icon="mdi-cat">Cat Things</vc-button-split>
        <div :class="['mt-16']">
          <code>v-model: {{ split1 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" xs24>
        <h4 :class="subheading">Disabled, "large" size</h4>
        <vc-button-split
          color="deep-purple"
          :dark="true"
          :items="button2"
          :disabled="true"
          header-click-value="guitars"
          size="large"
          :dropdown-z-index="500"
          @input="onInput($event)"
          icon="mdi-guitar-pick">Guitar Brands</vc-button-split>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ButtonSplitPage',
  data () {
    return {
      title: null,
      description: null,
      subheading: ['subheading', 'font-grey', 'font-l-600'],
      split1: 'cat things',
      button1: [{
        label: 'Martin',
        value: 'martin ivanov',
        avatar: '/static/images/avatar-01.png',
        secondaryText: 'Cat Owner',
        icon: 'account_circle'
      }, {
        label: 'Whisper',
        value: 'whisper',
        avatar: '/static/images/avatar-02.png',
        secondaryText: 'Cat',
        icon: 'home'
      }, {
        label: 'Shushi',
        value: 'shushi',
        avatar: '/static/images/avatar-02.png',
        secondaryText: 'Cat',
        icon: 'home'
      }, {
        label: 'Alex',
        value: 'alexandra dilcheva',
        avatar: '/static/images/avatar-03.png',
        secondaryText: 'Cat Owner',
        icon: 'home'
      }, {
        label: 'Gabriela',
        value: 'gabriela kehayova',
        avatar: '/static/images/avatar-04.png',
        secondaryText: 'Admin',
        icon: 'home'
      }],
      split2: 'guitars',
      button2: [{
        label: 'B.C. Rich',
        value: 'bcrich'
      }, {
        label: 'Jackson',
        value: 'jackson',
        disabled: true
      }, {
        label: 'ESP',
        value: 'esp',
        disabled: true
      }, {
        label: 'Strandberg',
        value: 'strandberg'
      }, {
        label: 'Gibson',
        value: 'gibson',
        disabled: true
      }, {
        label: 'Ibanez',
        value: 'ibanez'
      }, {
        label: 'Aurellia',
        value: 'aurellia'
      }, {
        label: 'Fender',
        value: 'fender'
      }, {
        label: 'Etherial',
        value: 'etherial'
      }, {
        label: 'Schecter',
        value: 'schecter'
      }, {
        label: 'Gretsch',
        value: 'gretsch'
      }, {
        label: 'Alvarez',
        value: 'alvarez'
      }, {
        label: 'Blueridge',
        value: 'Blueridge'
      }, {
        label: 'Breedlove',
        value: 'breedlove'
      }, {
        label: 'Carvin / Kiesel',
        value: 'carvin-kiesel'
      }, {
        label: 'Charvel',
        value: 'charvel'
      }, {
        label: 'Cordoba',
        value: 'cordoba'
      }, {
        label: 'Daisy Rock',
        value: 'daisy-rock'
      }, {
        label: 'Dean',
        value: 'dean'
      }, {
        label: 'Epiphone',
        value: 'epiphone'
      }, {
        label: 'Music Man',
        value: 'music-man'
      }, {
        label: 'EVH',
        value: 'evh'
      }, {
        label: 'Godin',
        value: 'godin'
      }, {
        label: 'Kramer',
        value: 'kramer'
      }, {
        label: 'Martin',
        value: 'martin'
      }, {
        label: 'Ovation',
        value: 'ovation'
      }, {
        label: 'PRS',
        value: 'prs'
      }, {
        label: 'Sterling by Music Man',
        value: 'sterling-by-music-man'
      }]
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  },
  methods: {
    onInput (event) {
      console.log('vc-button-split:input', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/button-split.vue